/*
  AoA · Seguro contra la cortina pegada de Klaviyo (Bryan, 2026-10-12).

  Qué pasa: el formulario FULLSCREEN de Klaviyo («Take 11% OFF») pone una cortina fija sobre toda la página y la
  clase body.klaviyo-prevent-body-scrolling (overflow: hidden !important). Al cerrarlo, a veces la cortina termina su
  desvanecido (opacity 0) pero Klaviyo no la retira ni quita la clase: la página se ve normal, pero no baja, no sube
  y no recibe clics. Reproducido en la vista previa el 2026-10-12 (TRASPASO, cierre 71).

  Qué hace este seguro, cada medio segundo:
  1. Si un diálogo de Klaviyo lleva más de 1 s invisible (opacity 0 o visibility hidden) pero sigue montado, lo
     esconde (display: none) para que deje de tapar los clics.
  2. Si el body tiene la clase que bloquea el scroll y no queda ningún diálogo de Klaviyo visible durante más de 1 s,
     quita la clase y el scroll vuelve.
  No toca el formulario mientras se ve ni mientras se abre (el desvanecido de entrada dura 0.35 s, por debajo del
  segundo de gracia). No modifica nada de Klaviyo: solo actúa sobre un estado que ya quedó roto.
*/
(function () {
  'use strict';
  var LOCK = 'klaviyo-prevent-body-scrolling';
  var SEL = '[role="dialog"][class*="kl-private-reset-css"]';
  var GRACIA = 1000;
  var invisibleDesde = typeof WeakMap === 'function' ? new WeakMap() : null;
  var bloqueoSinDialogoDesde = 0;

  function visible(el) {
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0;
  }

  function revisar() {
    var ahora = Date.now();
    var dialogos = document.querySelectorAll(SEL);
    var hayVisible = false;
    for (var i = 0; i < dialogos.length; i++) {
      var d = dialogos[i];
      if (d.getAttribute('data-aoa-guard') === 'hidden') continue;
      var cs = getComputedStyle(d);
      if (cs.display === 'none') continue;
      if (visible(d)) { hayVisible = true; if (invisibleDesde) invisibleDesde.delete(d); continue; }
      if (!invisibleDesde) continue;
      var desde = invisibleDesde.get(d);
      if (!desde) { invisibleDesde.set(d, ahora); continue; }
      if (ahora - desde > GRACIA) {
        d.style.display = 'none';
        d.setAttribute('data-aoa-guard', 'hidden');
      }
    }
    if (document.body.classList.contains(LOCK) && !hayVisible) {
      if (!bloqueoSinDialogoDesde) bloqueoSinDialogoDesde = ahora;
      else if (ahora - bloqueoSinDialogoDesde > GRACIA) {
        document.body.classList.remove(LOCK);
        bloqueoSinDialogoDesde = 0;
      }
    } else {
      bloqueoSinDialogoDesde = 0;
    }
  }

  function iniciar() {
    revisar();
    setInterval(revisar, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
